import { WoEnv } from './types';
import { environment as fallbackEnvironment } from './environment';
export * from './types';

type KeystoreResponse = Readonly<{
  success: boolean;
  error: unknown;
  data: Readonly<{ value: string, key: string; }> | undefined;
  messageId: string;
}>;

type Bridge = Readonly<{
  keystore: Readonly<{
    store: (key: string, value: string, biometry: boolean, callback: (response: KeystoreResponse) => void) => void,
    retrieve: (key: string, callback: (response: KeystoreResponse) => void) => void,
    remove: (key: string, callback: (response: KeystoreResponse) => void) => void,
  }>;
}>;

declare global {
  interface Window {
    ISS_ENV?: WoEnv;
    ISS_ENV_MOBILE?: boolean;
    Bridge?: Bridge;
  }
}

export const environment: WoEnv = window.ISS_ENV || fallbackEnvironment;
export { versionInfo, VersionInfo } from './version-info';
